module.exports = __webpack_public_path__ + "static/media/flashing_heart@2x.c3c24efa.png";